$(document).ready(function () {
  var swiper = new Swiper(".awardInnerSlider", {
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    slidesPerView: "auto",
    loop: true,
    speed: 8000,
  });

  var swiper = new Swiper(".logoInnerSlider", {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    slidesPerView: "2",
    loop: true,
    speed: 800,
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 4,
      },
      1025: {
        slidesPerView: 8,
      },
    },
  });

  // var swiper = new Swiper("#testimonialSlider", {
  //   autoplay: {
  //     delay: 0,
  //     disableOnInteraction: false,
  //   },
  //   slidesPerView: "auto",
  //   loop: true,
  //   speed: 8000,
  // });

  var swiper = new Swiper("#testimonialSlider", {
    loop: true,
    nextButton: ".mainTestimonial .swiper-button-next",
    prevButton: ".mainTestimonial .swiper-button-prev",
    slidesPerView: 1,
    speed: 1200,
    paginationClickable: true,
    spaceBetween: 20,
    watchOverflow: true,
    centeredSlides: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      1280: {
        slidesPerView: 3,
      },
      1366: {
        slidesPerView: 4.5,
      },
      2500: {
        slidesPerView: 5.5,
      },
    },
    navigation: {
      nextEl: ".mainTestimonial .custom-next", // Use custom next button class
      prevEl: ".mainTestimonial .custom-prev", // Use custom prev button class
    },
  });

  var swiper = new Swiper("#articlesSlider", {
    loop: true,
    nextButton: ".mainArticles .swiper-button-next",
    prevButton: ".mainArticles .swiper-button-prev",
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 20,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
      },
      1366: {
        slidesPerView: 4.5,
      },
    },
    navigation: {
      nextEl: ".mainArticles .custom-next", // Use custom next button class
      prevEl: ".mainArticles .custom-prev", // Use custom prev button class
    },
  });

  var swiper = new Swiper("#articlesSlidernew", {
    loop: true,
    nextButton: ".mainArticles .swiper-button-next",
    prevButton: ".mainArticles .swiper-button-prev",
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 20,
    autoplay: false,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
      },
      1366: {
        slidesPerView: 4.5,
      },
    },
    navigation: {
      nextEl: ".mainArticles .custom-next", // Use custom next button class
      prevEl: ".mainArticles .custom-prev", // Use custom prev button class
    },
  });

  var swiper = new Swiper("#recentlyViewedSlider", {
    loop: true,
    nextButton: ".mainRecentlyViewed .swiper-button-next",
    prevButton: ".mainRecentlyViewed .swiper-button-prev",
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
      },
      1366: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: ".mainRecentlyViewed .custom-next", // Use custom next button class
      prevEl: ".mainRecentlyViewed .custom-prev", // Use custom prev button class
    },
  });

  var swiper = new Swiper("#productListSlider", {
    loop: true,
    nextButton: ".productList .swiper-button-next",
    prevButton: ".productList .swiper-button-prev",
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
      },
      1366: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: ".productList .custom-next", // Use custom next button class
      prevEl: ".productList .custom-prev", // Use custom prev button class
    },
  });

  var swiper = new Swiper("#relatedArticlesSlider", {
    loop: true,
    nextButton: ".mainRelatedArticles .swiper-button-next",
    prevButton: ".mainRelatedArticles .swiper-button-prev",
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
      },
      1366: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: ".mainRelatedArticles .custom-next", // Use custom next button class
      prevEl: ".mainRelatedArticles .custom-prev", // Use custom prev button class
    },
  });

  var swiper = new Swiper(".articleSwiper", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  // Product page accordion
  // Open the first section by default
  $(".accordion-body").first().slideDown();
  $(".accordion-header")
    .first()
    .find(".arrow")
    .css("transform", "rotate(180deg)");

  $(".accordion-header").click(function () {
    var $body = $(this).next(".accordion-body");
    var $arrow = $(this).find(".arrow");

    // Check if this section is already open
    if ($body.is(":visible")) {
      // If it's open, close it and rotate the arrow down
      $body.stop(true, true).slideUp();
      $arrow.css("transform", "rotate(0deg)");
    } else {
      // If it's closed, open it and rotate the arrow up
      $(".accordion-body").slideUp(); // Close all other sections
      $(".arrow").css("transform", "rotate(0deg)"); // Reset arrows to down

      $body.stop(true, true).slideDown(300, function () {
        // Callback after the slideDown animation
        var offsetTop = $(this).prev(".accordion-header").offset().top; // Get the position of the header
        var headerWrapperHeight = $(".header-wrapper").outerHeight(); // Get the height of the header-wrapper
        $("html, body").animate(
          {
            scrollTop: offsetTop - headerWrapperHeight - 100, // Subtract the header-wrapper height and offset
          },
          500
        ); // Scroll smoothly in 500ms
      }); // Open the clicked section
      $arrow.css("transform", "rotate(180deg)"); // Rotate arrow to up
    }
  });


  $(document).on("click",".needsclick",function(){
    $("body").addClass("close-klaviyo");
  });
  
});

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-link");
  const panes = document.querySelectorAll(".tab-pane");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const targetTab = this.dataset.tab;

      tabs.forEach((t) => t.classList.remove("active"));
      panes.forEach((p) => {
        if (p.dataset.tab === targetTab) {
          p.classList.add("active");
        } else {
          p.classList.remove("active");
        }
      });

      this.classList.add("active");
    });
  });
});

if (window.innerWidth <= 768) {
  $(".footer-block").each(function () {
    const $section = $(this);
    const $h2 = $section.find(".footer-block__heading");
    const $ul = $section.find("ul.footer-block__details-content");

    $ul.hide();

    if (!$h2.find(".toggle-icon").length) {
      $h2.prepend('<span class="toggle-icon">+</span> ');
    }

    $h2.on("click", function () {
      const $icon = $(this).find(".toggle-icon");
      const isOpen = $ul.is(":visible");

      $ul.slideToggle();
      $icon.text(isOpen ? "+" : "–");
    });
  });
}